// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
var initialState = {};
export var supportMaterialSlice = createSlice({
    name: "supportMaterials",
    initialState: initialState,
    reducers: {
        setSupportMaterial: function (state, action) {
            state[action.payload.id] = action.payload;
            return state;
        },
    },
});
export var setSupportMaterial = supportMaterialSlice.actions.setSupportMaterial;
export var selectSupportMaterialById = function (supportMaterialId) { return function (state) {
    return state.supportMaterials[supportMaterialId];
}; };
export var getSupportMaterialsList = function () { return function (state) {
    return state.supportMaterials;
}; };
export default supportMaterialSlice.reducer;
